export default __webpack_public_path__ + "static/media/ISTJ-3.58ac5d18.png";